const data4 = [
  { investorType: 'Mutual FUnd', overvaluationReason: 'Profitability', count : 5 },
  { investorType: 'Hedge Fund', overvaluationReason: 'Profitability', count : 2 },
  { investorType: 'Institutionnal', overvaluationReason: 'Profitability', count : 10 },
  { investorType: 'type4', overvaluationReason: 'Profitability', count : 4 },
  { investorType: 'type5', overvaluationReason: 'Profitability', count : 4 },
  
  { investorType: 'Mutual FUnd', overvaluationReason: 'Growth', count : 3 },
  { investorType: 'Hedge Fund', overvaluationReason: 'Growth', count : 1 },
  { investorType: 'Institutionnal', overvaluationReason: 'Growth', count : 6 },
  { investorType: 'type4', overvaluationReason: 'Growth', count : 4 },
  { investorType: 'type5', overvaluationReason: 'Growth', count : 3 },
  
  { investorType: 'Mutual FUnd', overvaluationReason: 'Strategy', count : 4 },
  { investorType: 'Hedge Fund', overvaluationReason: 'Strategy', count : 2 },
  { investorType: 'Institutionnal', overvaluationReason: 'Strategy', count : 1 },
  { investorType: 'type4', overvaluationReason: 'Strategy', count : 2 },
  { investorType: 'type5', overvaluationReason: 'Strategy', count : 2 },
 
  { investorType: 'Mutual FUnd', overvaluationReason: 'Competitive Position', count : 1 },
  { investorType: 'Hedge Fund', overvaluationReason: 'Competitive Position', count : 2 },
  { investorType: 'Institutionnal', overvaluationReason: 'Competitive Position', count : 2 },
  { investorType: 'type4', overvaluationReason: 'Competitive Position', count : 1 },
  { investorType: 'type5', overvaluationReason: 'Competitive Position', count : 2 },
];

export default data4;
